import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    titles: [
      'G.',
      'Gđa'
    ]
  },
  getters: {
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/dropdowns.js